import { MultiWait } from '../js/util/multiwait';

const ui: any = {};

ui.uniqueID = 1;
ui._element = $('<div class="ui" />');
ui._zIndex = 10;
ui._dialogs = [];
ui._templates = {};
ui._templateFiles = [];

ui.loadTemplateFile = (name: any) => {
    ui._templateFiles.push(name);
};

ui.loadTemplates = (basePath: any, callback: any) => {
    const waitAll = new MultiWait();

    for (let i = 0; i < ui._templateFiles.length; ++i) {
        const name = ui._templateFiles[i];
        const template = $("<div />");
        template.load(basePath + "/" + name, waitAll.one());
        ui._templates[name] = template;
    }

    $("body").append(ui._element);
    waitAll.wait(callback);
};

ui.loadFromTemplate = (name: any) => {
    return ui._templates[name].children(".dialog").clone();
};

ui.addDialog = (dialog: any) => {
    ui._element.append(dialog._element);
    ui._dialogs.push(dialog);
    ui.bringToTop(dialog);
};

ui.removeDialog = (dialog: any) => {
    let index = ui._dialogs.indexOf(dialog);
    if (index === -1) {
        console.warn("Attempted to remove an unregistered dialog");
        return;
    }

    dialog._element.remove();
    dialog._element = null;
    ui._dialogs.splice(index, 1);
    ui._updateDialogOrder();
};

ui.bringToTop = (dialog: any) => {
    // Do something with dialog
    const index = ui._dialogs.indexOf(dialog);
    if (index === -1) {
        console.warn("Attempted to bring to top an unregistered dialog");
        return;
    }

    ui._dialogs.splice(index, 1);
    ui._dialogs.push(dialog);
    ui._updateDialogOrder();
};

ui._updateDialogOrder = () => {
    for (let i = 0; i < ui._dialogs.length; ++i) {
        ui._dialogs[i]._element.css("z-index", ui._zIndex + i);
    }
};

ui._getWidgetElement = (type: any, widget: any, arg1: any, arg2: any) => {
    let element = null;

    if (arg1 instanceof ui.Widget && typeof arg2 === "string") {
        element = arg1._element.find(arg2);
    } else if (arg1 instanceof jQuery) {
        element = arg1;
    } else if (typeof arg1 === "string") {
        const classes = arg1.split(".");
        element = widget.Create();
        for (let i = 0; i < classes.length; ++i) {
            if (classes[i].length) {
                element.addClass(classes[i]);
            }
        }
    } else if (arg1 === undefined && arg2 === undefined) {
        element = widget.Create();
    }

    if (element instanceof jQuery && element.length === 0) {
        element = null;
    }

    if (element) {
        if (element.length > 1) {
            throw new Error(
                "Tried to create a new " +
                    type +
                    " on a jQuery object with multiple elements"
            );
        }

        if (!element.hasClass(type)) {
            throw new Error(
                "Tried to create a new " +
                    type +
                    " widget on an element without the class"
            );
        }
    }

    return element;
};

ui.widgetConstructor = (name: any, widget: any) => {
    return (arg1: any, arg2: any) => {
        const element = ui._getWidgetElement(name, widget, arg1, arg2);

        if (element) {
            return new widget(element);
        } else {
            return null;
        }
    };
};

ui.KEY_CODES = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    PAUSE: 19,
    CAPS_LOCK: 20,
    ESCAPE: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 45,
    HOME: 46,
    LEFT_ARROW: 37,
    UP_ARROW: 38,
    RIGHT_ARROW: 39,
    DOWN_ARROW: 40,
    INSERT: 45,
    DELETE: 46,
};

(window as any).ui = ui;

// Stuff...  Everything extends `ui`.
require("./gameui.ts");
require("./nameplate.ts");

// Widgets
require("./widgets/widget.ts");
require("./widgets/dialog.ts");
require("./widgets/button.ts");
require("./widgets/checkbox.ts");
require("./widgets/iconslot.ts");
require("./widgets/label.ts");
require("./widgets/list.ts");
require("./widgets/panel.ts");
require("./widgets/progressbar.ts");
require("./widgets/radiogroup.ts");
require("./widgets/tabpanel.ts");
require("./widgets/textbox.ts");
require("./widgets/titlebar.ts");
require("./widgets/slider.ts");

// Dialogs
require("./dialogs/charactercreate.ts");
require("./dialogs/characterselect.ts");
require("./dialogs/characterstatus.ts");
require("./dialogs/chatbox.ts");
require("./dialogs/character.ts");
require("./dialogs/debug.ts");
require("./dialogs/gamemaster.ts");
require("./dialogs/inventory.ts");
require("./dialogs/knowledgebase.ts");
require("./dialogs/login.ts");
require("./dialogs/menu.ts");
require("./dialogs/map.ts");
require("./dialogs/minimap.ts");
require("./dialogs/messagebox.ts");
require("./dialogs/news.ts");
require("./dialogs/npcchat.ts");
require("./dialogs/npcstore.ts");
require("./dialogs/party.ts");
require("./dialogs/quantitydialog.ts");
require("./dialogs/questlist.ts");
require("./dialogs/register.ts");
require("./dialogs/serverselect.ts");
require("./dialogs/skills.ts");
require("./dialogs/status.ts");
require("./dialogs/quickbar.ts");
require("./dialogs/buffbar.ts");
require("./dialogs/options.ts");
require("./dialogs/trade.ts");
require("./dialogs/vending.ts");

export { ui };
